import { useState } from 'react';

import Button from 'lib/components/button/Button';
import Input from 'lib/components/input/Input';
import Modal from 'lib/components/modal/Modal';

import './MoveQuestionPositionModal.scss';

const MoveQuestionPositionModal = ({
  isOpen,
  min,
  max,
  current,
  onSubmit,
  onRequestClose,
}) => {
  const [position, setPosition] = useState('');

  const targetIndex = parseInt(position, 10) - 1;
  const isValid =
    Number.isFinite(targetIndex) &&
    targetIndex >= min &&
    targetIndex <= max &&
    targetIndex !== current;

  return (
    <Modal
      title='Move question to position'
      className='move-question-position-modal'
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={onRequestClose}
      data-testid='MoveQuestionPositionModal.dialog'
      actions={
        <Button
          disabled={!isValid}
          onClick={() => onSubmit(targetIndex)}
          data-testid='MoveQuestionPositionModal.submit'
        >
          Move question
        </Button>
      }
    >
      <Input
        label={`Position (${min + 1} - ${max + 1})`}
        type='number'
        min={min + 1}
        max={max + 1}
        value={position}
        placeholder={`${current + 1}`}
        onChange={(e) => setPosition(e.target.value)}
        data-testid='MoveQuestionPositionModal.position'
      />
      <p className='position-hint'>
        The question is at position {current + 1}. Questions with dependencies
        can only move between their dependency and their dependents.
      </p>
    </Modal>
  );
};

export default MoveQuestionPositionModal;
